import React, { useEffect } from 'react';

/* ─────────────────────────────────────────────
   Field index reference (from get_payslip_data output row)
   0  record id
   1  Full Legal Name
   2  Myid
   3  Address
   4  Pay Frequency (TotalPayStatus)
   5  Annual Salary
   6  Start Date
   7  date_range  ("dd/mm/yyyy - dd/mm/yyyy")
   8  Payment Date
   9  Type_Employee
   10 Gross Salary Current
   11 Email
   12 Net Salary Current
   13 Ordinary Hours
   14 Ordinary Rate
   15 Ordinary Gross Current
   16 YTD Ordinary Gross
   17 Sat Hours
   18 Sat Rate
   19 Sat Gross
   20 YTD Sat Gross
   21 Sun Hours
   22 Sun Rate
   23 Sun Gross
   24 Sun GrossYTD
   25 Annual Used (current)
   26 Annual Leave Current
   27 Annual Leave Payments YTD
   28 Sick Used
   29 Personal Current
   30 Personal Payments
   31 Termin Used Hours
   32 Termination Pay
   33 Termin YTD
   34 Leave Loading Current
   35 YTD Leave Loading
   36 Bonus-Commission Current
   37 YTD Bonus-Commission
   38 Total Gross (this pay)
   39 PAYG Current
   40 PAYG YTD
   41 Super Fund Name
   42 Super composite  ("Myid-SuperFund-Membership")
   43 Super Current
   44 YTD Super
   45 Annual Accrued
   46 Annual Used (duplicate)
   47 Annual Balance
   48 TFNStatus
   49 TIH Hours
   50 TIH Rate
   51 TIH Gross
   52 TIH GrossYTD
   53 Double Hours
   54 Double Rate
   55 Double Gross
   56 Double GrossYTD
   57 PH Hours
   58 PH Rate
   59 PH Gross
   60 PH GrossYTD
   61 LSL Hours
   62 LSL Rate
   63 LSL Pay
   64 LSL YTD
   ───────────────────────────────────────────── */

/* ---------- Inline styles ---------- */
const overlayStyle = {
  position: 'fixed',
  inset: 0, top: 'var(--fr-modal-top, 0px)',
  background: 'rgba(0,0,0,0.75)',
  backdropFilter: 'blur(6px)',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  zIndex: 1050,
  padding: '40px 20px',
  overflowY: 'auto',
};

const modalStyle = {
  background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
  border: '1px solid rgba(34, 211, 238, 0.25)',
  borderRadius: 18,
  width: '100%',
  maxWidth: 920,
  boxShadow: '0 25px 80px rgba(0,0,0,0.6), 0 0 60px rgba(34,211,238,0.08)',
  position: 'relative',
  overflow: 'hidden',
};

const gradientBarStyle = {
  height: 3,
  background: 'linear-gradient(90deg, #22d3ee, #3b82f6, #8b5cf6)',
};

const headerStyle = {
  padding: '20px 24px 16px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '1px solid rgba(255,255,255,0.06)',
};

const titleStyle = {
  fontSize: '1.1rem',
  fontWeight: 700,
  color: '#f1f5f9',
  letterSpacing: '-0.01em',
  margin: 0,
};

const closeBtnStyle = {
  background: 'rgba(255,255,255,0.05)',
  border: '1px solid rgba(255,255,255,0.1)',
  color: 'rgba(255,255,255,0.6)',
  width: 32,
  height: 32,
  borderRadius: 8,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 18,
  lineHeight: 1,
  transition: 'all 0.2s',
};

const bodyStyle = {
  padding: '16px 24px 8px',
  maxHeight: 'calc(100dvh - var(--fr-modal-top, 0px) - 220px)',
  overflowY: 'auto',
};

const sectionLabelStyle = {
  fontSize: '0.7rem',
  fontWeight: 700,
  color: '#22d3ee',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  margin: '14px 0 8px',
  paddingLeft: 4,
};

const rowStyle = (cols) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
  gap: 10,
  marginBottom: 10,
});

const fieldWrapStyle = {
  position: 'relative',
};

const fieldLabelStyle = {
  position: 'absolute',
  top: 6,
  left: 12,
  fontSize: '0.62rem',
  fontWeight: 600,
  color: 'rgba(34,211,238,0.7)',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  pointerEvents: 'none',
};

const fieldInputStyle = {
  width: '100%',
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(34,211,238,0.15)',
  borderRadius: 8,
  padding: '22px 12px 8px',
  fontSize: '0.85rem',
  color: '#f1f5f9',
  fontFamily: 'monospace',
  outline: 'none',
  boxSizing: 'border-box',
};

const footerStyle = {
  padding: '16px 24px',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 10,
  borderTop: '1px solid rgba(255,255,255,0.06)',
  background: 'rgba(0,0,0,0.2)',
};

const baseBtnStyle = {
  padding: '10px 22px',
  borderRadius: 10,
  fontSize: '0.85rem',
  fontWeight: 600,
  cursor: 'pointer',
  border: 'none',
  transition: 'all 0.2s',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
};

const cancelBtnStyle = {
  ...baseBtnStyle,
  background: 'rgba(255,255,255,0.06)',
  color: 'rgba(255,255,255,0.7)',
  border: '1px solid rgba(255,255,255,0.1)',
};

const primaryBtnStyle = {
  ...baseBtnStyle,
  background: 'linear-gradient(135deg, #22d3ee 0%, #3b82f6 100%)',
  color: '#0f172a',
  fontWeight: 700,
  boxShadow: '0 4px 14px rgba(34,211,238,0.3)',
};

/* ---------- Field component ---------- */
const Field = ({ label, value, mono = true }) => (
  <div style={fieldWrapStyle}>
    <span style={fieldLabelStyle}>{label}</span>
    <input
      type="text"
      readOnly
      value={value ?? ''}
      style={{ ...fieldInputStyle, fontFamily: mono ? 'monospace' : 'inherit' }}
    />
  </div>
);

/* ---------- Main modal ---------- */
const PayslipModal = ({ record, onClose, onSubmit, submitting }) => {
  // Esc key to close
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !submitting) onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, submitting]);

  if (!record) return null;

  // Build the form payload that maps 1:1 to the Flask /tfnpayslip endpoint
  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitting) return;

    const form = e.currentTarget;
    const formData = new FormData(form);
    onSubmit(formData);
  };

  const r = record;

  return (
    <div style={overlayStyle} onClick={(e) => e.target === e.currentTarget && !submitting && onClose()}>
      <div style={modalStyle}>
        <div style={gradientBarStyle} />

        <div style={headerStyle}>
          <h5 style={titleStyle}>Creating Payslip — TFN Employee</h5>
          <button
            type="button"
            style={closeBtnStyle}
            onClick={onClose}
            disabled={submitting}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={bodyStyle}>
            {/* Hidden id fields */}
            <input type="hidden" name="myid" value={r[2] || ''} />
            <input type="hidden" name="endofmonthtfn23" value={r[8] || ''} />
            <input type="hidden" name="myemail" value={r[11] || ''} />

            {/* ── Employee ── */}
            <div style={sectionLabelStyle}>Employee</div>
            <div style={rowStyle(1)}>
              <Field label="Legal Name" value={r[1]} mono={false} />
            </div>
            <div style={rowStyle(1)}>
              <Field label="Address" value={r[3]} mono={false} />
            </div>
            <div style={rowStyle(3)}>
              <Field label="Pay Frequency" value={r[4]} mono={false} />
              <Field label="Annual Salary" value={r[5]} />
              <Field label="Employee Type" value={r[9]} mono={false} />
            </div>
            <div style={rowStyle(2)}>
              <Field label="Pay Period" value={r[7]} mono={false} />
              <Field label="Payment Date" value={r[8]} mono={false} />
            </div>

            {/* Hidden form inputs that mirror the original HTML names */}
            <input type="hidden" name="legalName" value={r[1] || ''} />
            <input type="hidden" name="address" value={r[3] || ''} />
            <input type="hidden" name="payFreq" value={r[4] || ''} />
            <input type="hidden" name="annualsalary" value={r[5] || ''} />
            <input type="hidden" name="employType" value={r[9] || ''} />
            <input type="hidden" name="payPeriod" value={r[7] || ''} />
            <input type="hidden" name="payDate" value={r[8] || ''} />

            {/* ── Totals ── */}
            <div style={sectionLabelStyle}>Totals</div>
            <div style={rowStyle(2)}>
              <Field label="Total Earnings" value={r[10]} />
              <Field label="Net Payment" value={r[12]} />
            </div>
            <input type="hidden" name="totalEarnings" value={r[10] || ''} />
            <input type="hidden" name="netPay" value={r[12] || ''} />

            {/* ── Ordinary ── */}
            <div style={sectionLabelStyle}>Ordinary</div>
            <div style={rowStyle(4)}>
              <Field label="Ordinary Hours" value={r[13]} />
              <Field label="Ordinary Rate" value={r[14]} />
              <Field label="Ordinary Pay" value={r[15]} />
              <Field label="Ordinary YTD" value={r[16]} />
            </div>
            <input type="hidden" name="ordHours" value={r[13] || ''} />
            <input type="hidden" name="ordRate" value={r[14] || ''} />
            <input type="hidden" name="ordPay" value={r[15] || ''} />
            <input type="hidden" name="ordYTD" value={r[16] || ''} />

            {/* ── Saturday ── */}
            <div style={sectionLabelStyle}>Saturday</div>
            <div style={rowStyle(4)}>
              <Field label="Saturday Hours" value={r[17]} />
              <Field label="Saturday Rate" value={r[18]} />
              <Field label="Saturday Pay" value={r[19]} />
              <Field label="Saturday YTD" value={r[20]} />
            </div>
            <input type="hidden" name="satHours" value={r[17] || ''} />
            <input type="hidden" name="satRate" value={r[18] || ''} />
            <input type="hidden" name="satPay" value={r[19] || ''} />
            <input type="hidden" name="satYTD" value={r[20] || ''} />

            {/* ── Sunday ── */}
            <div style={sectionLabelStyle}>Sunday</div>
            <div style={rowStyle(4)}>
              <Field label="Sunday Hours" value={r[21]} />
              <Field label="Sunday Rate" value={r[22]} />
              <Field label="Sunday Pay" value={r[23]} />
              <Field label="Sunday YTD" value={r[24]} />
            </div>
            <input type="hidden" name="sunHours" value={r[21] || ''} />
            <input type="hidden" name="sunRate" value={r[22] || ''} />
            <input type="hidden" name="sunPay" value={r[23] || ''} />
            <input type="hidden" name="sunYTD" value={r[24] || ''} />

            {/* ── TIH ── */}
            <div style={sectionLabelStyle}>TIH (Time-in-Hand)</div>
            <div style={rowStyle(4)}>
              <Field label="TIH Hours" value={r[49]} />
              <Field label="TIH Rate" value={r[50]} />
              <Field label="TIH Pay" value={r[51]} />
              <Field label="TIH YTD" value={r[52]} />
            </div>
            <input type="hidden" name="TIHHours" value={r[49] || ''} />
            <input type="hidden" name="TIHRate" value={r[50] || ''} />
            <input type="hidden" name="TIHPay" value={r[51] || ''} />
            <input type="hidden" name="TIHYTD" value={r[52] || ''} />

            {/* ── Double ── */}
            <div style={sectionLabelStyle}>Double Time</div>
            <div style={rowStyle(4)}>
              <Field label="Double Hours" value={r[53]} />
              <Field label="Double Rate" value={r[54]} />
              <Field label="Double Pay" value={r[55]} />
              <Field label="Double YTD" value={r[56]} />
            </div>
            <input type="hidden" name="DoubleHours" value={r[53] || ''} />
            <input type="hidden" name="DoubleRate" value={r[54] || ''} />
            <input type="hidden" name="DoublePay" value={r[55] || ''} />
            <input type="hidden" name="DoubleYTD" value={r[56] || ''} />

            {/* ── Public Holiday ── */}
            <div style={sectionLabelStyle}>Public Holiday</div>
            <div style={rowStyle(4)}>
              <Field label="PH Hours" value={r[57]} />
              <Field label="PH Rate" value={r[58]} />
              <Field label="PH Pay" value={r[59]} />
              <Field label="PH YTD" value={r[60]} />
            </div>
            <input type="hidden" name="PhHours" value={r[57] || ''} />
            <input type="hidden" name="PhRate" value={r[58] || ''} />
            <input type="hidden" name="PhPay" value={r[59] || ''} />
            <input type="hidden" name="PhYTD" value={r[60] || ''} />

            {/* ── Annual Leave ── */}
            <div style={sectionLabelStyle}>Annual Leave</div>
            <div style={rowStyle(4)}>
              <Field label="Annual Hours" value={r[25]} />
              <Field label="Annual Rate" value={r[14]} />
              <Field label="Annual Pay" value={r[26]} />
              <Field label="Annual YTD" value={r[27]} />
            </div>
            <input type="hidden" name="annualHours" value={r[25] || ''} />
            <input type="hidden" name="annualRate" value={r[14] || ''} />
            <input type="hidden" name="annualPay" value={r[26] || ''} />
            <input type="hidden" name="annualYTD" value={r[27] || ''} />

            {/* ── Personal Leave ── */}
            <div style={sectionLabelStyle}>Personal Leave</div>
            <div style={rowStyle(4)}>
              <Field label="Personal Hours" value={r[28]} />
              <Field label="Personal Rate" value={r[14]} />
              <Field label="Personal Pay" value={r[29]} />
              <Field label="Personal YTD" value={r[30]} />
            </div>
            <input type="hidden" name="personalHours" value={r[28] || ''} />
            <input type="hidden" name="personalRate" value={r[14] || ''} />
            <input type="hidden" name="personalPay" value={r[29] || ''} />
            <input type="hidden" name="personalYTD" value={r[30] || ''} />

            {/* ── Termination ── */}
            <div style={sectionLabelStyle}>Termination</div>
            <div style={rowStyle(4)}>
              <Field label="Termination Hours" value={r[31]} />
              <Field label="Termination Rate" value={r[14]} />
              <Field label="Termination Pay" value={r[32]} />
              <Field label="Termination YTD" value={r[33]} />
            </div>
            <input type="hidden" name="termHours" value={r[31] || ''} />
            <input type="hidden" name="termRate" value={r[14] || ''} />
            <input type="hidden" name="termPay" value={r[32] || ''} />
            <input type="hidden" name="termYTD" value={r[33] || ''} />

            {/* ── Loading ── */}
            <div style={sectionLabelStyle}>Leave Loading</div>
            <div style={rowStyle(4)}>
              <Field label="Loading Hours" value={r[25]} />
              <Field label="Loading Rate" value={r[14]} />
              <Field label="Loading Pay" value={r[34]} />
              <Field label="Loading YTD" value={r[35]} />
            </div>
            <input type="hidden" name="loadingHours" value={r[25] || ''} />
            <input type="hidden" name="loadingRate" value={r[14] || ''} />
            <input type="hidden" name="loadingPay" value={r[34] || ''} />
            <input type="hidden" name="loadingYTD" value={r[35] || ''} />

            {/* ── Bonus / Commission ── */}
            <div style={sectionLabelStyle}>Bonus / Commission</div>
            <div style={rowStyle(4)}>
              <Field label="Other Hours" value="0.00" />
              <Field label="Other Rate" value="$0.00" />
              <Field label="Other Pay" value={r[36]} />
              <Field label="Other YTD" value={r[37]} />
            </div>
            <input type="hidden" name="commissionHours" value="0.00" />
            <input type="hidden" name="commissionRate" value="$0.00" />
            <input type="hidden" name="commissionPay" value={r[36] || ''} />
            <input type="hidden" name="commissionYTD" value={r[37] || ''} />

            {/* ── Long Service ── */}
            <div style={sectionLabelStyle}>Long Service Leave</div>
            <div style={rowStyle(4)}>
              <Field label="LSL Hours" value={r[61]} />
              <Field label="LSL Rate" value={r[62]} />
              <Field label="LSL Pay" value={r[63]} />
              <Field label="LSL YTD" value={r[64]} />
            </div>
            <input type="hidden" name="longHours" value={r[61] || ''} />
            <input type="hidden" name="longRate" value={r[62] || ''} />
            <input type="hidden" name="longPay" value={r[63] || ''} />
            <input type="hidden" name="longYTD" value={r[64] || ''} />

            {/* ── Pay Summary ── */}
            <div style={sectionLabelStyle}>Pay Summary</div>
            <div style={rowStyle(3)}>
              <Field label="Amount Net" value={r[12]} />
              <Field label="Total Pay Gross" value={r[38]} />
              <Field label="Total YTD Gross" value={r[38]} />
            </div>
            <input type="hidden" name="amountnet" value={r[12] || ''} />
            <input type="hidden" name="totalPayGross" value={r[38] || ''} />
            <input type="hidden" name="totalPayYTD" value={r[38] || ''} />

            {/* ── PAYG ── */}
            <div style={sectionLabelStyle}>PAYG</div>
            <div style={rowStyle(4)}>
              <Field label="PAYG" value={r[39]} />
              <Field label="Total PAYG" value={r[39]} />
              <Field label="PAYG YTD" value={r[40]} />
              <Field label="Total PAYG YTD" value={r[40]} />
            </div>
            <input type="hidden" name="paygnet" value={r[39] || ''} />
            <input type="hidden" name="paygnetTotal" value={r[39] || ''} />
            <input type="hidden" name="paygnetYtd" value={r[40] || ''} />
            <input type="hidden" name="paygnetTotalYTD" value={r[40] || ''} />

            {/* ── Super ── */}
            <div style={sectionLabelStyle}>Superannuation</div>
            <div style={rowStyle(1)}>
              <Field label="Super Fund" value={r[41]} mono={false} />
            </div>
            <div style={rowStyle(4)}>
              <Field label="Super" value={r[43]} />
              <Field label="Total Super" value={r[43]} />
              <Field label="Super YTD" value={r[44]} />
              <Field label="Total Super YTD" value={r[44]} />
            </div>
            <input type="hidden" name="supername" value={r[41] || ''} />
            <input type="hidden" name="super" value={r[43] || ''} />
            <input type="hidden" name="superTotal" value={r[43] || ''} />
            <input type="hidden" name="superYtd" value={r[44] || ''} />
            <input type="hidden" name="superTotalYTD" value={r[44] || ''} />

            {/* ── Leave Balances ── */}
            <div style={sectionLabelStyle}>Annual Leave Balances</div>
            <div style={rowStyle(3)}>
              <Field label="Accrued" value={r[45]} />
              <Field label="Used" value={r[46]} />
              <Field label="Balance" value={r[47]} />
            </div>
            <input type="hidden" name="accrued" value={r[45] || ''} />
            <input type="hidden" name="usedNet" value={r[46] || ''} />
            <input type="hidden" name="balance" value={r[47] || ''} />
          </div>

          <div style={footerStyle}>
            <button
              type="button"
              style={cancelBtnStyle}
              onClick={onClose}
              disabled={submitting}
            >
              Close
            </button>
            <button
              type="submit"
              style={{ ...primaryBtnStyle, opacity: submitting ? 0.6 : 1, cursor: submitting ? 'wait' : 'pointer' }}
              disabled={submitting}
            >
              {submitting ? 'Creating…' : 'Create Payslip'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PayslipModal;